import { render, staticRenderFns } from "./commune.vue?vue&type=template&id=7d5cf12a"
import script from "./commune.vue?vue&type=script&lang=js"
export * from "./commune.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports